import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import util from "../util/util";

export default function CampaignListSearchForm(props) {
  const [search, setSearch] = useState(props.search || ``); // search string value;

  useEffect(() => {
    setSearch(props.search);
  }, [props]);

  // go to a new URL with the selected form values;
  const onSearchSubmit = () => {
    let url = `${util.returnCampaignListUrl()}?sort=${props.sort}`;

    if (search.length) {
      url = `${url}&search=${search}`;
    }

    const params = {
      url: url,
      search: search
    };

    props.searchSubmit(params);
  };

  // reset search form values to their default state;
  const onSearchReset = () => {
    setSearch(``);
  };

  // if the key pressed is `enter` then submit the search form;
  const onKeyPress = e => {
    if (e.key === `Enter`) {
      onSearchSubmit();
    }
  };

  return (
    <div className="form-inline search-form">
      <div className="form-group">
        <label htmlFor="search-form__search">Search</label>
        <input
          autoFocus
          id="search-form__search"
          className="form-control"
          type="text"
          value={search}
          onChange={e => setSearch(e.target.value.trim())}
          onKeyPress={e => onKeyPress(e)}
        />
      </div>

      <div className="search-form__buttons">
        <button className="btn btn-default" onClick={() => onSearchSubmit()}>
          <i className="fa fa-search" aria-hidden="true"></i>
          Apply Filters
        </button>

        <button className="btn btn-link" onClick={() => onSearchReset()}>
          Reset Filters
        </button>
      </div>
    </div>
  );
}

CampaignListSearchForm.propTypes = {
  search: PropTypes.string,
  sort: PropTypes.string, // not editable from this component, but needs to be passed in the form;
  searchSubmit: PropTypes.func
};
